import { Page, PageFace } from 'ui/components/Page'
import { PanelFace } from 'ui/components/Panel'
import { BSABreadcrumbs } from 'ui/temp'
import { BSA_MODULE_PATH } from '~bank-bsa-reporting/constants'

import { BSABatchesTable, Filter, Footer } from './components'
import { CTRBatchesChosenItemsContextProvider } from './context/CTRBatchesChosenItemsContext'

import { s } from './styles'

const BatchList = () => (
  <CTRBatchesChosenItemsContextProvider>
    <Page
      face={PageFace.PRIMARY}
      title={<BSABreadcrumbs title="CTR Batch List" parentUrl={BSA_MODULE_PATH} parentTitle="BSA Reporting" />}
      footer={<Footer />}
    >
      <s.TablePanel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <BSABatchesTable />
      </s.TablePanel>
    </Page>
  </CTRBatchesChosenItemsContextProvider>
)

export default BatchList
